import React from 'react';
import { Card } from '@/components/ui/card';
import { FileSpreadsheet } from 'lucide-react';

export default function ExportInstructionsCard() {
  return (
    <Card className="p-6 bg-blue-50 border-blue-200 mb-8">
      <div className="flex items-start gap-3">
        <FileSpreadsheet className="w-6 h-6 text-blue-600 mt-1" />
        <div>
          <h3 className="font-bold text-lg mb-2">Export Detailed Report</h3>
          <p className="text-sm text-muted-foreground mb-3">
            Click the "Export to Excel" button to download a comprehensive report including:
          </p>
          <ul className="text-sm text-muted-foreground list-disc list-inside space-y-1">
            <li>Complete booking details (ID, date, time, duration, status)</li>
            <li>Customer information (name, email, phone, type)</li>
            <li>Location and court assignments</li>
            <li>Financial data (gross amount, discounts, final amount)</li>
            <li>Payment methods and discount reasons</li>
            <li>Special requests and timestamps</li>
          </ul>
          <p className="text-xs text-muted-foreground mt-3 italic">
            * The Excel file will open in Microsoft Excel, Google Sheets, or any spreadsheet application
          </p>
        </div>
      </div>
    </Card>
  );
}
